import { render, staticRenderFns } from "./FlvPlayerRealTimeNew.vue?vue&type=template&id=4f55d3bb&scoped=true"
import script from "./FlvPlayerRealTimeNew.vue?vue&type=script&lang=js"
export * from "./FlvPlayerRealTimeNew.vue?vue&type=script&lang=js"
import style0 from "./FlvPlayerRealTimeNew.vue?vue&type=style&index=0&id=4f55d3bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f55d3bb",
  null
  
)

export default component.exports